import { computed, ref, defineComponent } from 'vue';
import { useGraph, useViewModel } from '@baklavajs/renderer-vue';
import useDragMove from '../custom/useDragMove';
export default defineComponent({
    props: {
        position: {
            type: Object,
            required: true,
        },
        rightclickCallback: {
            required: true,
            type: Function,
        },
    },
    setup(props) {
        // any definition is an ad-hoc solution as we don't have our graph definition
        const { graph } = useGraph();
        const { viewModel } = useViewModel();
        const radius = 7.5;
        const styles = computed(() => ({
            cx: `${(props.position.x + graph.value.panning.x) * graph.value.scaling}px`,
            cy: `${(props.position.y + graph.value.panning.y) * graph.value.scaling}px`,
            r: `${radius * graph.value.scaling}px`,
        }));
        const dragMove = useDragMove(ref(props.position));
        const stopDrag = () => {
            dragMove.onPointerUp();
            document.removeEventListener('pointermove', dragMove.onPointerMove);
            document.removeEventListener('pointerup', stopDrag);
        };
        const startDrag = (ev) => {
            if (viewModel.value.editor.readonly)
                return;
            dragMove.onPointerDown(ev);
            document.addEventListener('pointermove', dragMove.onPointerMove);
            document.addEventListener('pointerup', stopDrag);
        };
        return {
            styles,
            startDrag,
        };
    },
});
